import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminQuestions() {
  const [list, setList] = useState([]);
  const [sel, setSel] = useState(null);
  const [answer, setAnswer] = useState("");
  const load = () => api.get("/admin/questions").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const mark = async (id, status) => { await api.patch(`/admin/questions/${id}`, { status }); load(); };
  const saveAns = async () => { await api.patch(`/admin/questions/${sel.id}`, { answer, status: "answered" }); toast.success("Jawaban tersimpan"); setSel(null); setAnswer(""); load(); };
  return (
    <div>
      <h1 className="display text-4xl md:text-6xl mb-6">QUESTIONS</h1>
      <div className="grid md:grid-cols-[1fr,380px] gap-6">
        <div className="border border-[color:var(--border)]">
          {list.length === 0 ? <div className="p-6 text-neutral-500 text-sm">Belum ada pertanyaan.</div> : list.map((q) => (
            <div key={q.id} onClick={() => { setSel(q); setAnswer(q.answer || ""); if (q.status === "unread") mark(q.id, "open"); }} className={`p-4 border-b border-[color:var(--border)] cursor-pointer ${sel?.id === q.id ? "bg-[color:var(--surface)]" : ""}`}>
              <div className="flex justify-between text-xs">
                <span className="mono">{q.name} · {q.email}</span>
                <span className="status-badge">{q.status}</span>
              </div>
              <div className="text-sm mt-1 truncate">{q.message}</div>
            </div>
          ))}
        </div>
        {sel && (
          <aside className="border border-[color:var(--border)] p-4 h-fit">
            <div className="text-[10px] tracking-widest text-neutral-500">FROM</div>
            <div className="text-sm">{sel.name} · {sel.email} · {sel.phone || "—"}</div>
            <div className="text-[10px] tracking-widest text-neutral-500 mt-4">PESAN</div>
            <div className="text-sm whitespace-pre-line">{sel.message}</div>
            <div className="text-[10px] tracking-widest text-neutral-500 mt-4">JAWABAN INTERNAL</div>
            <textarea rows={4} value={answer} onChange={(e) => setAnswer(e.target.value)} className="w-full bg-transparent border border-[color:var(--border)] p-2 text-sm mt-1" />
            <div className="flex gap-2 mt-3">
              <button data-testid="ans-save" onClick={saveAns} className="bg-white text-black px-4 py-2 text-xs tracking-widest">SIMPAN JAWABAN</button>
              <button onClick={() => mark(sel.id, "closed")} className="border border-white px-4 py-2 text-xs tracking-widest">CLOSE</button>
            </div>
          </aside>
        )}
      </div>
    </div>
  );
}
